import { message } from 'antd';
import { parseIt } from './dotObjectExpander';

export interface DefaultError {
  title?: string;
  message?: string;
}

interface ValidationError {
  fieldName: string;
  reason: string;
  errorCodes: string[];
}

export interface IResponseError {
  data: { error: DefaultError; errors: ValidationError[] };
}

export interface IErrors {
  [key: string]: any;
}

export interface IMutationResponseError {
  error?: DefaultError;
  errors?: ValidationError[];
}

export interface IError {
  isValidationError?: boolean;
  error?: DefaultError;
  errors: IErrors;
}

function mapValidationError(errors: ValidationError[] = []) {
  const _errors: IErrors = {};

  for (const error of errors) {
    _errors[error.fieldName] = error.reason;
  }

  return parseIt(_errors);
}

function defaultError(error?: DefaultError) {
  if (error?.message === 'INVALID_TOKEN') {
    return { message: 'เซสชั่นหมดอายุ กรุณาเข้าสู่ระบบใหม่อีกครั้ง' };
  }
  if (!error) {
    return { message: 'ขออภัย เกิดข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง' };
  }

  return Object.assign(
    { message: 'ขออภัย เกิดข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง' },
    error,
  );
}

export function transformResponseError(responseError: IResponseError): IError {
  const { error, errors } = responseError?.data;
  const isValidationError = errors.length > 0;

  const _error = defaultError(error);

  if (!isValidationError) {
    message.error(_error.message);
  }

  return {
    isValidationError,
    error: _error,
    errors: mapValidationError(errors),
  };
}

export function transformMutationResponseError(
  responseError: IMutationResponseError,
): IError {
  const { error, errors } = responseError;

  const isValidationError = errors && errors.length > 0;

  const _error = defaultError(error);

  if (!isValidationError) {
    message.error(_error.message);
  }

  return {
    isValidationError,
    error: _error,
    errors: mapValidationError(errors),
  };
}
